import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

import CurrencyField from "components/_refactor/fields/number";
import InputText from "components/_refactor/text/input";

import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function ValuesSection({
  minimumValue,
  minimumQuantityPerOrder,
  byLine,
  byOrder,
  onChange,
}) {
  const minimumRule = byLine ? "line" : byOrder ? "order" : "";

  const handleRuleChange = (event) => {
    const value = event.target.value;
    onChange({
      byLine: value === "line",
      byOrder: value === "order",
    });
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <Box sx={{ width: "100%" }}>
          <CurrencyField
            placeholder="Valor mínimo"
            onChange={(e) => onChange({ minimumValue: e.floatValue || 0 })}
            value={minimumValue || 0}
            className="form-control"
            style={{ width: "100%" }}
            label="Valor mínimo"
            type="number"
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={8}>
        <FormControl component="fieldset" fullWidth>
          <Typography
            variant="body2"
            sx={{
              mb: 1,
              fontWeight: 600,
              color: themeColorsDesingSystem.text.primary,
            }}
          >
            Aplicar valor mínimo
          </Typography>
          <RadioGroup
            row
            value={minimumRule}
            onChange={handleRuleChange}
            sx={{ gap: 2 }}
          >
            <Box
              sx={{
                flex: 1,
                minWidth: 200,
                border: `1px solid ${
                  byLine
                    ? themeColorsDesingSystem.primary.main
                    : themeColorsDesingSystem.stone.main
                }`,
                borderRadius: 1,
                px: 2,
                py: 1,
                backgroundColor: byLine
                  ? `${themeColorsDesingSystem.primary.main}08`
                  : "transparent",
              }}
            >
              <FormControlLabel
                value="line"
                control={<Radio color="primary" />}
                label={
                  <Box>
                    <Typography variant="body2" fontWeight={600}>
                      Por linha
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: themeColorsDesingSystem.gray.dark }}
                    >
                      Cada linha do pedido deve atingir o valor mínimo.
                    </Typography>
                  </Box>
                }
                sx={{ alignItems: "flex-start", m: 0 }}
              />
            </Box>
            <Box
              sx={{
                flex: 1,
                minWidth: 200,
                border: `1px solid ${
                  byOrder
                    ? themeColorsDesingSystem.primary.main
                    : themeColorsDesingSystem.stone.main
                }`,
                borderRadius: 1,
                px: 2,
                py: 1,
                backgroundColor: byOrder
                  ? `${themeColorsDesingSystem.primary.main}08`
                  : "transparent",
              }}
            >
              <FormControlLabel
                value="order"
                control={<Radio color="primary" />}
                label={
                  <Box>
                    <Typography variant="body2" fontWeight={600}>
                      Por pedido
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: themeColorsDesingSystem.gray.dark }}
                    >
                      O pedido completo deve atingir o valor mínimo.
                    </Typography>
                  </Box>
                }
                sx={{ alignItems: "flex-start", m: 0 }}
              />
            </Box>
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <InputText
          placeholder="Quantidade mínima por pedido"
          onChange={(e) =>
            onChange({
              minimumQuantityPerOrder: Number(e.target.value) || 0,
            })
          }
          value={minimumQuantityPerOrder}
          className="form-control"
          style={{ width: "100%" }}
          label="Quantidade mínima por pedido"
          type="number"
        />
      </Grid>
    </Grid>
  );
}
